import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const guestGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser();
  
  if (user) {
    // Usuário já está logado, redirecionar para dashboard apropriado
    if (user.tipo === 'farmacia') {
      router.navigate(['/farmacia/dashboard']);
    } else {
      router.navigate(['/paciente/dashboard']);
    }
    return false;
  }

  return true;
};
